import React, { useMemo, useRef } from "react";
import { useRestApiProvider } from "@jugl-web/rest-api";
import { useEntitiesListProvider } from "@web-src/modules/entities/providers/EntitiesListProvider/useEntitiesListProvider";
import { PageLoaderFull } from "@jugl-web/ui-kit";
import {
  CXOnboardingFlow,
  CXOnboardingStep,
} from "../../components/CXOnboardingFlow";

export const CXOnboardingPage: React.FC = () => {
  const { usersApi } = useRestApiProvider();
  const { data: profileData } = usersApi.useGetUserProfileQuery({
    meta: { silent: true },
  });
  const hasProfile = !!profileData;
  const {
    entityInvitesState: { entityInvites, isFetching: isInvitesFetching },
  } = useEntitiesListProvider();

  const hasInvitations = entityInvites && entityInvites.length > 0;

  // Lock initialStep once computed to prevent re-renders from profile/entity
  // cache updates causing the flow to reset mid-submission
  const initialStepRef = useRef<CXOnboardingStep | null>(null);

  const initialStep = useMemo(() => {
    if (initialStepRef.current) return initialStepRef.current;
    if (isInvitesFetching) return null;

    let step: CXOnboardingStep;
    if (!hasProfile && hasInvitations) {
      step = "profile";
    } else if (hasInvitations) {
      step = "invitations";
    } else {
      step = "workspace";
    }
    initialStepRef.current = step;
    return step;
  }, [hasProfile, hasInvitations, isInvitesFetching]);

  if (!initialStep) {
    return <PageLoaderFull />;
  }

  return (
    <CXOnboardingFlow initialStep={initialStep} invitations={entityInvites} />
  );
};
